<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DRHLLG/tc-custom/9781683830238.jpg?1721057728665" alt="This image is the cover for the book Myths of the Asanas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Myths of the Asanas
      </h1>
      <p class="bookDescription body article font2">
        <b>The ancient lore behind yoga poses: “Transports us to a world where gods and goddesses, saints, and enlightened animals serve as our teachers.” —MC Yogi</b><br/><br/>Practitioners around the world reap the physical benefits of yoga, assuming poses frequently called by their Sanskrit names. While many know that<i> hanumanasana</i> is named for the deity Hanuman, few know why. But behind each asana and its corresponding movements is an ancient story about a god, sage, or sacred animal, much like Aesop’s fables or European folktales. <br/><br/><i>Myths of the Asanas</i> is the first book to collect and retell these ancient stories. The myths behind yoga’s spiritual tradition have the power to help students of all levels realize their full potential. Meditating on the tolerance of trees while standing in tree pose can help one become more tolerant. Learning how the disfigured sage Astavakra came to be the teacher of a king can liberate us from anxieties about our external appearance and our self-imposed limitations. Marveling at Hanuman’s devotion to Ram can serve as a source of spiritual strength and determination. With more than sixty beautiful illustrations to frame the stories, <i>Myths of the Asanas</i> will add a new dimension to your practice and study of yoga.<br/><br/>“Truly enhances our yogic lessons. Some of the nuances of ethics, posture, breath, and meditation can only be touched through metaphor and mythology and we thank them for taking us on this journey.” —Rodney Yee, author of <i>Moving Toward Balance</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alanna Kaivalya, Arjuna van der Kooij, Shiva Rea, Manorama
      </h2>
      
      <p class="authorDescription body article">Alanna Kaivalya, also known as "The JivaDiva," produces the JivaDiva Yoga Jam podcast, which has been heard by over a million people worldwide. In March 2008, Yoga Journal named Alanna one of the top twenty teachers under forty. She is a contributing writer to Yoga Journal, she regularly teaches at Yoga Journal conferences. She lives in New York City.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mandala Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5ba3e4c3